import React, { useState, useRef } from "react";
import debounce from "lodash/debounce";

import Results from "./Results";
import Icon from "../Icon";
import APIMaintenance from "../APIMaintenance";

const apiUrl = "/wp-json/salesforce/v1/funds";

const FundQuickSearch = ({ titlesMap = {}, maintenance, maintenanceMessageLine1, maintenanceMessageLine2 }) => {
  const queryEl = useRef(null);
  const [query, setQuery] = useState("");

  const handleSearch = debounce((value) => {
    setQuery("");
    setQuery(value);
  }, 300);

  // clear on outside click
  const body = document.querySelector("body");
  body.addEventListener("click", (event) => {
    if (!event.target.closest(".QuickSearch")) {
      setQuery("");
      if (queryEl.current) queryEl.current.value = "";
    }
  });

  return (
    <div className="QuickSearch">
      <form
        className="QuickSearch-form"
        onSubmit={(event) => event.preventDefault()}
      >
        <label htmlFor="QuickSearch-query" className="u-screenreader">
          Search for a disease or medication
        </label>
        <input
          autoComplete="off"
          id="QuickSearch-query"
          className="QuickSearch-query"
          type="text"
          ref={queryEl}
          onChange={(event) => handleSearch(event.target.value)}
          disabled={maintenance}
          placeholder={
            maintenance
              ? `${maintenanceMessageLine1} - ${maintenanceMessageLine2}`
              : "Search for a disease or medication"
          }
          style={maintenance ? { backgroundColor: "#D3D3D3" } : undefined}
        />
        <button className="QuickSearch-submit" type="submit">
          <span className="u-screenreader">Submit</span>
          Search
        </button>
      </form>

      {query && (
        <Results
          url={apiUrl}
          params={{ searchterm: query }}
          titlesMap={titlesMap}
        />
      )}
    </div>
  );
};

export default FundQuickSearch;
